import React, { useEffect, useRef, useState } from 'react';
import {toggleGlobalLoader, addErrorAlert, addLoadingAlert, removeLoadingAlert, addSuccessAlert} from "../../../store/calls/alertLoadingDispatch";
import AlertCard from '../../theme/cards/AlertCard';

function EmbedCodePreview({ subdomain, primaryColor}) {
  const addressRef = useRef(null); // Use useRef to persist the reference

  useEffect(() => {
    // Create the script element for the widget
    const script = document.createElement('script');
    
    // Set the script source to the remote-widgets.js file
    script.src = "https://s3.us-west-1.amazonaws.com/statichouse.pacefi.com/js/address_search.js";
    script.async = true;
    script.setAttribute('data-subdomain', subdomain);
    script.setAttribute('data-primary-color', primaryColor);
  
    // Append the script to the ref (the actual div where the widget should load)
    if (addressRef.current) {
      addressRef.current.appendChild(script);
    }

    // Optional: Add any additional scripts if needed after the initial script is loaded
    script.onload = () => {
      const addressWidgetLoadScript = document.createElement('script');
      addressWidgetLoadScript.text = `CFAddressWidget()`;

      if (addressRef.current) {
        addressRef.current.appendChild(addressWidgetLoadScript);
      }
    };

    // Cleanup: Remove the script elements when the component unmounts
    return () => {
      if (addressRef.current) {
        addressRef.current.innerHTML = ''; // Clean up the content inside the div
      }
    };
  }, []); // The empty dependency array ensures that this effect runs once on component mount

  return (
    <div>
      {/* The div where the widget will be injected */}
      <div id="cf-address" ref={addressRef} />
    </div>
  );
}



function EmbedCodeGenerator({ subdomain, primaryColor }) {
    const formContainerRef = useRef(null);
  
    // The embed code that the user can copy
    const [embedCode, setEmbedCode] = useState('');
    const [codeIsHovered, setCodeIsHovered] = useState(false)
  
    // Construct the embed code dynamically based on the subdomain
    useEffect(() => {
      const code = `
        <script src="https://s3.us-west-1.amazonaws.com/statichouse.pacefi.com/js/address_search.js" 
        data-subdomain="${subdomain}"
        data-primary-color="${primaryColor}"
        async="true">
        </script>
      `;
      setEmbedCode(code);
    }, [subdomain]);
  
    // Function to copy the embed code
    const handleCopy = () => {
      navigator.clipboard.writeText(embedCode)
        .then(() => addSuccessAlert('Embed code copied to clipboard'))
        .catch(() => addErrorAlert('Failed to copy embed code.'));
    };
  

    return (
      <div>
        <div>
          <AlertCard
            type="info"
          >
            <div>
                <p>Copy and paste this embed code into your website where you would like element to appear:</p>
                <div className="my-4">
                    <code>{embedCode}</code>
                </div>
                <div className='buttons is-right'>
                    <div className='button is-primary is-outlined' onClick={handleCopy}>Copy</div>
                </div>
            </div>
    
          </AlertCard>
        </div>
  
        <p className='has-text-weight-semibold mt-6 mb-4'>This is how it will look on your website:</p>
        {/* The div that the script will target */}
        <EmbedCodePreview subdomain={subdomain} primaryColor={primaryColor}/>
      </div>
    );
  }

export default EmbedCodeGenerator;
